<template>
  <div class="content-block">
    <CompanyTemplateTable></CompanyTemplateTable>
  </div>
</template>

<script>
import { get, filter, head, map, orderBy } from 'lodash'
import CompanyTemplateTable from 'CORE/components/settings/company-template/table'

export default {
    name: 'SettingsCompanyTemplateView',
    components: {
        CompanyTemplateTable,
    },
    data() {
        return {
            groups: [],
        }
    },
    computed: {

    },
    mounted() {
        // this.groups = orderBy(this.$store.getters.userGroups, ['name'], ['asc'])
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>

</style>
